import {
  dbui_v1_CreateFunctionRequest,
  dbuiV1CreateFunctionMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useCreateNotebookFunction = () => {
  const { workspace } = useWorkspace();
  return useMutation({
    mutationFn: (data: dbui_v1_CreateFunctionRequest) =>
      dbuiV1CreateFunctionMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: data, path: { workspace } }),
  });
};
